import React from "react";
import { default as ReactSelect, components } from "react-select";

const ReactSelectField = (props: any) => {
  return (
    <>
      <div className="form-floating">
        <ReactSelect
          className="form-select"
          {...props}
          styles={{
            control: (provided: any) => ({
              ...provided,
              minHeight: "36px",
              position: "absolute",
              width: "101%",
              top: "-1px",
              backgroundColor: props.isDisabled ? "#fbfbfb" : "#ffffff",
              left: "-1px",
            }),
          }}
        >
          {props?.children}
        </ReactSelect>
        <label htmlFor="floatingSelect">{props?.placeholder}</label>
      </div>
    </>
  );
};

export default ReactSelectField;
